import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Badge, ButtonBase } from '@mui/material';
import React from 'react';
import { globalMenuWidthSmall } from '../../GlobalMenu/constants';
import { themeColorsDark } from '../../JuvareTheme/colors/themeColorsDark';
import { useCommonWebTranslation } from '../../hooks';
export const MenuButton = ({ menuOpen, menuBadge, onMenuToggle }) => {
    const { t } = useCommonWebTranslation();
    const icon = menuOpen ? React.createElement(MenuOpenIcon, null) : React.createElement(MenuIcon, null);
    return (React.createElement(ButtonBase, { focusRipple: true, "aria-label": t('common.menu'), "aria-haspopup": 'menu', "aria-expanded": menuOpen, sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'stretch',
            width: globalMenuWidthSmall - 4,
            minWidth: globalMenuWidthSmall - 4,
            mr: '4px',
            // Global App header is always dark.
            color: themeColorsDark.icon.subtle,
            '&:hover': {
                backgroundColor: themeColorsDark.overlay.hover,
            },
        }, onClick: (event) => {
            onMenuToggle(!menuOpen);
            event.stopPropagation();
        } }, menuBadge ? (React.createElement(Badge, { color: 'secondary', variant: 'dot', sx: {
            '& .MuiBadge-dot': {
                // Global App header is always dark.
                backgroundColor: themeColorsDark.accent.red.subtle,
            },
        } }, icon)) : (icon)));
};
